import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const accommodationAgeGroupCapacityEntity: Entity = {
  model: model,
  repository: repository,
}

export default accommodationAgeGroupCapacityEntity
